<template>
	<SOSlotModal
		:modal-title="'Ringkasan'"
		:modal-id="id"
		:no-padding="true"
		@close="close"
	>
		<template v-slot:modal-body>
			<div class="d-flex justify-content-center p-x-20 p-y-20" v-if="isLoading">
				<span
					class="spinner-border f-c-blue"
					role="status"
					aria-hidden="true"></span>
			</div>
			<div v-else>
				<div class="modal-body border-bottom">
					<div class="d-flex-between-center p-y-8">
						<div class="d-block">
							<div class="f-regular f-16 f-c-black">
								Transaksi Self Service
							</div>
							<div class="f-regular f-14 f-c-midgrey">
								Total {{ info.data.total_transaksi_selfservice | currency }}
							</div>
						</div>
						<div class="f-regular f-16 f-c-black">
							{{ formatRupiah(info.data.total_nota_selfservice) }} Nota
						</div>
					</div>
					<div class="separator-line-dot"></div>

					<div class="d-flex-between-center p-y-8">
						<div class="d-block">
							<div class="f-regular f-16 f-c-black">
								Transaksi Drop Off
							</div>
							<div class="f-regular f-14 f-c-midgrey">
								Total {{ info.data.total_transaksi_dropoff | currency }}
							</div>
						</div>
						<div class="f-regular f-16 f-c-black">
							{{ formatRupiah(info.data.total_nota_dropoff) }} Nota
						</div>
					</div>
				</div>
				<div class="modal-body">
					<div class="d-flex-between-center p-y-8">
						<div class="f-regular f-16 color-6f7">Belum Lunas</div>
						<div class="f-regular f-16 f-c-black">{{ formatRupiah(info.data.jumlah_belum_lunas) }} Nota
						</div>
					</div>
					<div class="separator-line-dot"></div>

					<div class="d-flex-between-center p-y-8">
						<div class="f-regular f-16 color-6f7">Belum Selesai</div>
						<div class="f-regular f-16 f-c-black">{{ formatRupiah(info.data.jumlah_belum_selesai) }} Nota
						</div>
					</div>
					<div class="separator-line-dot"></div>
				</div>
			</div>
		</template>
		<template v-slot:modal-footer>
			<div class="modal-body border-bottom" v-if="!isLoading">
				<div class="f-regular f-12 f-c-midgrey">
					Data dari {{ formatRupiah(info.data.total_nota_selfservice + info.data.total_nota_dropoff) }} Nota,
					mulai {{ info.data.periode_awal }} hingga {{ info.data.periode_akhir }}.
				</div>
			</div>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";

export default {
	name: "TransaksiSnapcleanModalRingkasan",
	components: {
		SOSlotModal
	},
	props: {
		isLoading: {
			type: Boolean,
			default: true,
		}
	},
	data() {
		return {
			id: "modal-ringkasan-transaksi",
		}
	},
	computed: {
		...mapGetters("transaksiSnapcleanModule", {
			info: "getInfoTransaksiKonsumen",
		})
	},
	mounted() {
		$("#" + this.id).modal("show");
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
	}
}
</script>